module.exports = __webpack_public_path__ + "static/img/index6.67af3e5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index6.gif
// module id = tfmi
// module chunks = 0